import { render, staticRenderFns } from "./Krepost.vue?vue&type=template&id=48767f11&scoped=true"
import script from "./Krepost.vue?vue&type=script&lang=js"
export * from "./Krepost.vue?vue&type=script&lang=js"
import style0 from "./Krepost.vue?vue&type=style&index=0&id=48767f11&prod&lang=scss&scoped=true"
import style1 from "./Krepost.vue?vue&type=style&index=1&id=48767f11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48767f11",
  null
  
)

export default component.exports